export default "__VITE_ASSET__BVmXnET2__"